import { render, staticRenderFns } from "./ViewAwardsText.vue?vue&type=template&id=7b54fcf9&scoped=true"
import script from "./ViewAwardsText.vue?vue&type=script&lang=js"
export * from "./ViewAwardsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b54fcf9",
  null
  
)

export default component.exports